import { AxiosRequestConfig } from 'axios';
import { ajax, HttpResponse } from '../../../../common/ajax';
import { config } from '../../config';
import { CustomerPreferences } from '../../models/Customers';

interface IOptInService {
  consent: (
    optInType: number,
    state: boolean,
    source: number,
    channelType?: number,
    channelValue?: boolean,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
  preferences: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<CustomerPreferences>>;
}

export const optInService: IOptInService = {
  consent(
    optInType: number,
    state: boolean,
    source: number,
    channelType?: number,
    channelValue?: boolean,
    axiosConfig?: AxiosRequestConfig,
  ) {
    return ajax.post<boolean>(
      `${config.benefitApiUrl}/opt-in/consent?optInType=${optInType}`,
      {
        state,
        source,
        channelType,
        channelValue,
      },
      axiosConfig,
    );
  },
  preferences(axiosConfig?: AxiosRequestConfig) {
    return ajax.get<CustomerPreferences>(
      `${config.benefitApiUrl}/opt-in/preferences`,
      axiosConfig,
    );
  },
};
